import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import ButtonSpinner from "./ButtonSpinner";
import { classNames } from "../../shared/utility";

const VARIANT_CLASSES = {
  default: {
    main: "bg-white text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50",
    chevron:
      "bg-white text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50",
  },
  primary: {
    main: "bg-[var(--color-btn-primary)] text-white hover:bg-[var(--color-accent-dark)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent",
    chevron:
      "bg-[var(--color-btn-primary)] text-white hover:bg-[var(--color-accent-dark)] border-l border-white/20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent",
  },
  secondary: {
    main: "border border-border bg-card text-brand hover:bg-accent-soft",
    chevron: "border border-border bg-card text-brand hover:bg-accent-soft",
  },
  danger: {
    main: "bg-red-600 text-white hover:bg-red-500",
    chevron: "bg-red-600 text-white hover:bg-red-500 border-l border-white/20",
  },
  success: {
    main: "bg-green-600 text-white hover:bg-green-500",
    chevron:
      "bg-green-600 text-white hover:bg-green-500 border-l border-white/20",
  },
};

export default function ButtonDropdown(props) {
  const {
    items,
    mainOption,
    mainAction,
    disabled,
    variant = "default",
  } = props;
  const colors = VARIANT_CLASSES[variant] || VARIANT_CLASSES.default;

  return (
    <div className="relative inline-flex rounded-md shadow-sm">
      <button
        type="button"
        className={classNames(
          "relative inline-flex items-center rounded-l-md px-3 py-2 text-sm font-semibold focus:z-10 disabled:cursor-not-allowed disabled:opacity-50",
          colors.main,
        )}
        onClick={mainAction}
        disabled={disabled}
      >
        {mainOption}
      </button>
      <Menu as="div" className="relative -ml-px block">
        <MenuButton
          className={classNames(
            "relative inline-flex items-center rounded-r-md px-2 py-2 focus:z-10",
            colors.chevron,
          )}
          disabled={disabled}
        >
          <span className="sr-only">Open options</span>
          <ChevronDownIcon aria-hidden="true" className="size-5" />
        </MenuButton>
        <MenuItems
          transition
          className="absolute right-0 z-50 -mr-1 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
        >
          <div className="py-1">
            {items.map((item) => (
              <MenuItem key={item.name}>
                <button
                  onClick={item.onClick}
                  className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none w-full"
                >
                  <ButtonSpinner spin={item.inProgress} text={item.name} />
                </button>
              </MenuItem>
            ))}
          </div>
        </MenuItems>
      </Menu>
    </div>
  );
}
